import React from "react";
import KC_Heading2 from "../../../../../designsystem/typography/KC-Heading/KC_Heading2";
import KC_Text from "../../../../../designsystem/typography/KC_Text/KC_Text";
import KC_Toggle from "../../../../../designsystem/KC_FormInput/KC_Toggle";
import KC_Button, {
  KC_ButtonSize
} from "../../../../../designsystem/KC_Button/KC_Button";
import {
  KC_Text_Sizes,
  KC_Weights
} from "../../../../../designsystem/ds_commons";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { tt } from "../../../../../utils/i18n/i18n";
import TwemojiWrapper from "../../../../../components/TwemojiWrapper/TwemojiWrapper";
import PrizesConfiguratorDisplayCard from "../component/PrizesConfiguratorDisplayCard";
import type { Config } from "kadow-jetpack-model";

const SECTION_DESCRIPTION_CLASS = "text-secondary";

interface CustomerOfMonthSectionProps {
  config: Config;
  onToggleLeaderboardEnabled: () => void;
  onChooseLeaderboardClick: () => void;
}

const choosePrizesButtonBaseProps = {
  size: KC_ButtonSize.Large,
  text: tt("prizes_configurator_choose_my_prize"),
  isPrimary: true,
  showIconOnTheRight: true,
  icon: faArrowRight,
  extraStyle: { width: "unset !important" as const }
};

const CustomerOfMonthSection: React.FC<CustomerOfMonthSectionProps> = ({
  config,
  onToggleLeaderboardEnabled,
  onChooseLeaderboardClick
}) => {
  const leaderboardSpecialPrize = config.lty?.leaderboardSpecialPrize;

  return (
    <section className="prizes-config-section">
      <div className="prizes-config-section__header">
        <div className="prizes-config-section__title-block">
          <div className="prizes-config-section__title-row">
            <KC_Heading2 text={tt("loyalty_customer_of_month_section_title")} />
            <KC_Toggle
              id="leaderboard-enabled-toggle"
              isChecked={!!config?.lty?.leaderboardEnabled}
              onToggle={onToggleLeaderboardEnabled}
            />
          </div>
          <KC_Text
            size={KC_Text_Sizes.lg}
            weight={KC_Weights.reg}
            text={tt("loyalty_leaderboard_special_prize_desc")}
            className={SECTION_DESCRIPTION_CLASS}
          />
        </div>
        {!!config?.lty?.leaderboardEnabled && (
          <div className="prizes-config-section__actions">
            <KC_Button
              id="choose-leaderboard-prizes"
              {...choosePrizesButtonBaseProps}
              onClick={onChooseLeaderboardClick}
            />
          </div>
        )}
      </div>
      {!!config?.lty?.leaderboardEnabled && (
        <div className="prizes-config-section__content prizes-config-section__content--padded">
          <PrizesConfiguratorDisplayCard
            className="prizes-configurator-display-card--leaderboard"
            title={
              leaderboardSpecialPrize?.type === "prize" &&
              leaderboardSpecialPrize.prize
                ? leaderboardSpecialPrize.prize.name ||
                  tt("prizes_configurator_no_name_gift")
                : tt("loyalty_tokens_count", {
                    count:
                      (
                        leaderboardSpecialPrize as {
                          amount?: number;
                        }
                      )?.amount ?? 100
                  })
            }
            secondaryText={tt("loyalty_leaderboard_top_customer_reward_desc")}
            badge={<TwemojiWrapper isBigText={true}>🏆</TwemojiWrapper>}
            media={
              leaderboardSpecialPrize?.type === "prize" &&
              leaderboardSpecialPrize.prize ? (
                <TwemojiWrapper isBigText={true}>
                  {leaderboardSpecialPrize.prize.image || "🎁"}
                </TwemojiWrapper>
              ) : (
                <span className="prizes-configurator-display-card__token-coin">
                  <TwemojiWrapper>🪙</TwemojiWrapper>
                </span>
              )
            }
          />
        </div>
      )}
    </section>
  );
};

export default CustomerOfMonthSection;
